import { ArrowLeft } from 'phosphor-react'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import background from 'src/assets/product-config/background-signin.png'
import logo from 'src/assets/product-config/logo-white.png'

export const Success: FC = () => {
  const navigate = useNavigate()
  return (
    <div
      style={{
        backgroundImage: `url(${background})
    `,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
      }}
      className="w-full h-screen flex justify-center items-center gap-20 max-2xl:gap-0"
    >
      <div className="bg-black items-center bg-opacity-40 gap-4 rounded-3xl backdrop-filter backdrop-blur-md border border-gray-600 p-12 flex flex-col">
        <img className="object-contain" width={200} src={logo} alt="" />

        <h2 className="text-white text-4xl text-center font-semibold mt-4 max-2xl:text-2xl">
          Tudo{' '}
          <strong className="text-[#4BBD9C] text-4xl max-2xl:text-xl text-center font-semibold">
            certo
          </strong>{' '}
          com as <br />
          informações!
        </h2>
        <p className="text-white text-2xl text-center font-extralight mt-8 max-2xl:text-xl max-2xl:mt-2">
          Agradecemos por abrir sua conta conosco! <br /> Para concluir a
          ativação, por favor, envie os documentos <br />
          solicitados para o e-mail{' '}
          <a
            className="text-blue-400 underline"
            href="mailto:bank@wtbo.com.br"
          >
            bank@wtbo.com.br
          </a>
          <br /> Estamos à disposição para ajudar!
        </p>

        <button
          onClick={() => navigate('/signin')}
          className="flex gap-2 items-center px-8 bg-zinc-900 h-16 border border-zinc-300 rounded-md font-bold text-white"
        >
          <ArrowLeft size={24} />
          Voltar para Login
        </button>
      </div>
    </div>
  )
}
